module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/swiss-knife-744bee2439000168a06c4e13a34c35eb.svg";